<template>
    <div id="pageTable">
        <v-container grid-list-xl fluid>
            <v-layout row wrap>

                <!-- Dialog fuulscreen para nova despesa -->
                <DespesasModal :reloadGrid="getDespesas" :relatorio="$route.params.uuid" v-if="isOpen" />

                <!-- Nome do projeto e status -->
                <v-flex xs6 sm8>
                    <div xs12><h4>{{ relatorio.report.projeto }}</h4></div>
                    <div xs12 v-if="isAdmin"><span>Funcionário: {{ relatorio.report.usuario.nome || '' }} ({{ relatorio.report.usuario.email || '' }})</span></div>
                    <div xs12>
                        <v-chip
                            small
                            :color="statusColor(this.relatorio.report.status)"
                            text-color="white"
                        >{{ relatorio.report.status }}</v-chip>
                        <span v-if="relatorio.report.dt_fechamento"> em {{ formatDate(relatorio.report.dt_fechamento) }}</span>
                    </div>
                </v-flex>

                <!-- Card de saldo -->
                <v-flex xs6 sm4>
                    <v-fade-transition>
                        <v-card class="elevation-8" :color="saldoColor" dark v-show="show">
                            <v-card-title class="pb-0">
                                <h4><b>Saldo</b></h4>
                            </v-card-title>
                            <v-card-text>
                                <h4>
                                    <b>{{ saldo | currency | placeholder('R$ 0,00') }} </b>
                                </h4>
                                <h5 v-if="saldoOffline != 0">
                                    <small :title="unsync"><b>(
                                        {{ saldoOffline >= 0 ? '+' : '-' }}
                                        {{ saldoOffline | currency }}
                                        <v-icon small>sync_problem</v-icon>
                                    )</b></small>
                                </h5>
                            </v-card-text>
                        </v-card>
                    </v-fade-transition>
                </v-flex>

                <!-- Data table  -->
                <v-flex lg12>
                    <v-card>
                        <v-toolbar card color="white">
                            <v-text-field sm8
                                flat
                                solo
                                prepend-icon="search"
                                placeholder="Filtro"
                                v-model="search"
                                hide-details
                            ></v-text-field>
                        </v-toolbar>
                        <v-divider></v-divider>
                        <v-card-text class="pa-0">
                            <v-data-table
                                :headers="despesasHeaders"
                                :search="search"
                                :items="relatorio.despesas"
                                :rows-per-page-items="[10, 25, 50, { text: 'All', value: -1 }]"
                                :loading="loading"
                                :no-data-text="semDados"
                                class="elevation-1"
                                item-key="name"
                            >
                                <template slot="items" slot-scope="props">
                                    <td><v-icon
                                        color="warning"
                                        :title="unsync"
                                        v-if="props.item.unsync"
                                    >sync_problem</v-icon></td>
                                    <td xs5>{{ props.item.categoria.nome || '' }}</td>
                                    <td xs2>{{ formatDateUTC(props.item.dt_despesa) }}</td>
                                    <td xs2>{{ props.item.valor | currency }}</td>
                                    <td xs2>
                                        <v-chip
                                            small
                                            text-color="white"
                                            :color="statusColor(signal(props.item.categoria.positivo))"
                                        >{{ signal(props.item.categoria.positivo) }}</v-chip>
                                    </td>
                                    <td xs2>
                                        <v-chip
                                            small
                                            text-color="white"
                                            :color="statusColor(props.item.status || 'Aguardando validação')"
                                        >{{ props.item.status || 'Aguardando validação' }}</v-chip>
                                    </td>
                                    <td xs1 class="no-wrap text-xs-right">
                                        <DespesasModal
                                            :reloadGrid="getDespesas"
                                            :relatorio="$route.params.uuid"
                                            :despesa="props.item"
                                            tableAction
                                            v-if="showBtn(props.item.status, props.item.unsync, props.item.categoria.positivo)"
                                        />
                                        <ExcluirModal
                                            :reloadGrid="getDespesas"
                                            :id="props.item._id"
                                            :route="route"
                                            :doc="props.item"
                                            v-if="showBtn(props.item.status, props.item.unsync, props.item.categoria.positivo)"
                                        />
                                        <DespesaDetailModal
                                            :reloadGrid="getDespesas"
                                            :despesa="props.item"
                                            :isEditable="isOpen && isAdmin && isOnline"
                                        />
                                    </td>
                                </template>
                            </v-data-table>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
import PouchDB              from 'pouchdb-browser';
import { mapState         } from 'vuex';
import { Items as Reports } from "@/api/report";
import VWidget              from '@/components/VWidget';
import AppFab               from '@/components/AppFab';
import ExcluirModal         from '@/components/crud/ExcluirModal';
import momentMixin          from '@/mixins/momentMixin';
import DespesasModal        from './DespesasModal';
import DespesaDetailModal   from './DespesaDetailModal';

let despesasDB = new PouchDB('despesas');

export default {
    mixins     : [momentMixin],
    components : {
        VWidget,
        AppFab,
        ExcluirModal,
        DespesasModal,
        DespesaDetailModal
    },
    computed   : {
        ...mapState(['user']),
        isAdmin() {
            return this.user.perfis.some(perfil => perfil === 'Administrador');
        },
        saldo() {
            return this.relatorio.despesas.map(item => {
                return (!item.unsync && item.status != 'Rejeitada') ? item.valor * (item.categoria.positivo ? 1 : -1) : 0;
            }).reduce((a, b) => a + b, 0).toFixed(2);
        },
        saldoOffline() {
            return this.relatorio.despesas.map(item => {
                return (item.unsync && item.status != 'Rejeitada') ? item.valor * (item.categoria.positivo ? 1 : -1) : 0;
            }).reduce((a, b) => a + b, 0).toFixed(2);
        },
        saldoColor() {
            return this.saldo >= 0 ? 'success' : 'error';
        },
        semDados() {
            return this.loading ? 'Buscando informações...' : 'Nenhuma despesa cadastrada';
        },
        isOpen() {
            return this.relatorio.report.status == 'Aberto';
        },
        unsync() {
            return "Não sincronizado";
        },
        computedDateFormatted () {
            return this.formatDate(this.date);
        },
        despesasHeaders() {
            let headers = [];

            headers.push({
                text     : '',
                align    : 'center',
                width    : 1,
                sortable : false,
                value    : ''
            });
            headers.push({
                text  : 'Categoria ',
                value : 'categoria.nome'
            });
            headers.push({
                text  : 'Data ',
                value : 'dt_despesa'
            });
            headers.push({
                text  : 'Valor ',
                value : 'valor'
            });
            headers.push({
                text  : 'Sinal ',
                value : 'categoria.positivo'
            });
            headers.push({
                text  : 'Status ',
                value : 'status'
            });
            headers.push({
                text     : 'Ações',
                align    : 'center',
                width    : 1,
                sortable : false,
                value    : ''
            });

            return headers;
        },
    },
    methods    : {
        signal(positivo) {
            return positivo  ? 'Positivo' : 'Negativo';
        },
        showBtn(status, unsync, positivo) {
            return (positivo || this.isAdmin) &&
                (unsync || (this.isOnline && this.isOpen && !['Aprovada', 'Rejeitada'].includes(status)));
        },
        statusColor (status) {
            const color = {
                // Status do Relatório
                "Fechado"              : "success",
                "Cancelado"            : "error",
                "Aberto"               : "warning",

                // Status da Despesa
                "Aprovada"             : "success",
                "Questionada"          : "warning",
                "Rejeitada"            : "error",
                "Aguardando validação" : "grey darker-1",

                // Sinal da Despesa
                "Positivo" : "success",
                "Negativo" : "error",
            }

            return color[status];
        },
        getRelatorio() {
            this.loading = true;
            if (this.isOnline) {
                this.$axios.get(`relatorios/${this.$route.params.uuid}`).then(response => {
                    this.relatorio.report = response.data
                }).then(() => {
                    this.loading = false;
                });
            } else {
                const uuid = this.$route.params.uuid;
                [this.relatorio.report] = this.$offlineStorage.get('relatorios').filter(function (rel) {
                    return rel._id == uuid;
                });
                this.loading = false;
            }
        },
        getDespesas() {
            this.loading = true;
            if (this.isOnline) {
                const filter = `?filter={"relatorio":"${this.$route.params.uuid}"}`;
                this.$axios.get(`${this.route}${filter}`).then(response => {
                    this.relatorio.despesas = response.data.items;
                    this.$offlineStorage.set(`despesas-${this.$route.params.uuid}`, response.data.items);
                });
            } else {
                this.relatorio.despesas = this.$offlineStorage.get(`despesas-${this.$route.params.uuid}`);
            }
            despesasDB.allDocs({include_docs: true, descending: true}, function(err, doc) {
                if (err) {
                    console.error('erro [allDocs()]', err);
                }
            }).then(despesasOff => {
                const categorias = this.$offlineStorage.get('categorias');
                despesasOff.rows.forEach(item => {
                    if (item.doc.relatorio == this.$route.params.uuid) {
                        item.doc.unsync = true;
                        [item.doc.categoria] = categorias.filter(cat => cat._id == item.doc.categoria);
                        this.relatorio.despesas.push(item.doc);
                    }
                });
                return this.relatorio.despesas;
            }).then(() => {
                this.loading = false;
            });
        },
        getColorByStatus (status) {
            return this.colors[status];
        }
    },
    watch      : {
        date (val) {
            this.dateFormatted = this.formatDate(this.date);
        }
    },
    data       : (vm) => ({
        loading     : true,
        search      : '',
        date        : vm.formatDate(new Date(), 'YYYY-MM-DD'),
        dtDespesaDP : vm.formatDate(new Date(), 'DD/MM/YYYY'),
        menu        : false,
        show        : false,
        route       : 'despesas',
        relatorio   : {
            report   : {
                usuario       : {
                    nome  : null,
                    email : null
                },
                dt_fechamento : null,
                status        : null
            },
            despesas : []
        },
        fullscreen  : {
            dialog        : false,
            notifications : false,
            sound         : true,
            widgets       : false
        },
    }),
    mounted() {
        this.getRelatorio();
        this.getDespesas();
        // console.log('$route:', this.$route.params.uuid);
        setTimeout(() => { this.show = true; }, 100);
    }
};
</script>

<style lang="stylus" scoped>
    .card-saldo
        max-height    : 105px;
        border-radius : 3px;
</style>
